import { computed, defineComponent } from 'vue';
import { flattenChildren } from '../_util/props-util';
import PropTypes from '../_util/vue-types';
import useConfigInject from '../_util/hooks/useConfigInject';
const buttonGroupProps = {
    prefixCls: PropTypes.string,
    size: {
        type: String,
    },
};
export { buttonGroupProps };
export default defineComponent({
    name: 'AButtonGroup',
    props: buttonGroupProps,
    setup(props, { slots }) {
        const { prefixCls, direction } = useConfigInject('btn-group', props);
        const classes = computed(() => {
            const { size } = props;
            // large => lg
            // small => sm
            let sizeCls = '';
            switch (size) {
                case 'large':
                    sizeCls = 'lg';
                    break;
                case 'small':
                    sizeCls = 'sm';
                    break;
                default:
                    break;
            }
            return {
                [`${prefixCls.value}`]: true,
                [`${prefixCls.value}-${sizeCls}`]: sizeCls,
                [`${prefixCls.value}-rtl`]: direction.value === 'rtl',
            };
        });
        return () => {
            var _a;
            return <div class={classes.value}>{flattenChildren((_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots))}</div>;
        };
    },
});
